import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE,
  FETCH_DRIVER_ESTIMATE,
  FETCH_DRIVER_ESTIMATE_SUCCESS,
  FETCH_DRIVER_ESTIMATE_FAILED,
  CLEAR_DRIVER_ESTIMATE,
  FETCH_RENTAL_ESTIMATE,
  FETCH_RENTAL_ESTIMATE_SUCCESS,
  FETCH_RENTAL_ESTIMATE_FAILED,
  CLEAR_RENTAL_ESTIMATE,
} from "../store/types";

const INITIAL_STATE = {
  estimate: null,
  rentalEstimate: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

const INITIAL_STATE_DRIVER = {
  driverEstimate: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const estimatereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ESTIMATE:
      return {
        ...state,
        loading: true
      };
    case FETCH_ESTIMATE_SUCCESS:
      return {
        ...state,
        estimate: action.payload,
        loading: false
      };
    case FETCH_ESTIMATE_FAILED:
      return {
        ...state,
        estimate: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case CLEAR_ESTIMATE:
      return INITIAL_STATE;
    case FETCH_DRIVER_ESTIMATE:
      return {
        ...state,
        loading: true
      };
    case FETCH_DRIVER_ESTIMATE_SUCCESS:
      return {
        ...state,
        driverEstimate: action.payload,
        loading: false
      };
    case FETCH_DRIVER_ESTIMATE_FAILED:
      return {
        ...state,
        driverEstimate: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case CLEAR_DRIVER_ESTIMATE:
      return INITIAL_STATE_DRIVER;

    case FETCH_RENTAL_ESTIMATE:
      return {
        ...state,
        loading: true
      };
    case FETCH_RENTAL_ESTIMATE_SUCCESS:
      return {
        ...state,
        rentalEstimate: action.payload,
        loading: false
      };
    case FETCH_RENTAL_ESTIMATE_FAILED:
      return {
        ...state,
        rentalEstimate: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case CLEAR_RENTAL_ESTIMATE:
      return INITIAL_STATE;


    default:
      return state;
  }
};